require('../../modules/es6.string.trim');
module.exports = require('../../modules/_core').String.trim;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/fn/string/trim.js
 ** module id = 371
 ** module chunks = 1
 **/